import { Analytics } from '@cobliteam/analytics';
import { AnimatePresence, motion } from 'motion/react';

import ButtonFilter from '@cobliteam/ui/components/ButtonFilter';
import Icon from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';
import { SidebarMenuButton } from '../../AppSidebar';
import { useSidebar } from '../../AppSidebar/components/Sidebar';

export interface MultiSelectVehicleGroupsSidebarTriggerPropsNew {
  totalSelectedGroups: number;
  isSidebarOpen?: boolean;
}

const MultiSelectVehicleGroupSidebarTriggerNew = ({ totalSelectedGroups }: MultiSelectVehicleGroupsSidebarTriggerPropsNew) => {
  const { state, openMobile } = useSidebar();
  const isCollapsed = state === 'collapsed';
  const hasSelectedGroups = totalSelectedGroups > 0;

  const onDropdownOpen = () => {
    Analytics.track('Global Filter Opened');
  };

  const SidebarButton = () => {
    return (
      <ButtonFilter
        className='w-52 border-primary-8 text-primary-8 hover:bg-primary-7'
        countBadge={totalSelectedGroups}
        icon={<Icon name='folders' />}
        onPressedChange={() => onDropdownOpen()}
        size='sm'
      >
        Grupo de Veículos
      </ButtonFilter>
    );
  };

  const CollapsedSidebarIcon = () => {
    return (
      <div className='relative'>
        {hasSelectedGroups && <div className='absolute top-1.5 right-1.5 z-20 flex size-2 items-center justify-center rounded-full bg-primary-9 text-white text-xs' />}
        <SidebarMenuButton
          size='sm'
          className={cn('relative border border-primary-8 bg-transparent text-primary-8', hasSelectedGroups && 'border-primary-9 bg-primary-5 text-primary-8 hover:bg-primary-7')}
        >
          <Icon name='folders' className={cn('size-4 text-primary-8', hasSelectedGroups && 'text-primary-11')} />
        </SidebarMenuButton>
      </div>
    );
  };

  return (
    <div className='flex w-full justify-center'>
      <AnimatePresence mode='wait'>
        {isCollapsed && !openMobile ? (
          <motion.div key='collapsed' initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }}>
            <CollapsedSidebarIcon />
          </motion.div>
        ) : (
          <motion.div key='expanded' initial={{ x: -50, opacity: 1 }} animate={{ x: 0, opacity: 1 }} exit={{ x: -200, opacity: 1 }} transition={{ duration: 0.2 }}>
            <SidebarButton />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MultiSelectVehicleGroupSidebarTriggerNew;
